import React from 'react';
import PropTypes from 'prop-types';
import HorizontalForm from 'components/form/horizontal_form';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

export default function HideInternallyCheckbox({ checked, onChange }) {
  return (
    <HorizontalForm.Checkbox
      label={
        <span>
          Hide from Non-Listing Brokers
          <OverlayTrigger
            overlay={
              <Tooltip id={`non-listing-broker-help-text-${Math.floor(Math.random() * 100000)}`}>
                Your company has elected to share listings with this status internally. You can hide this listing
                from other brokers by enabling this option.
              </Tooltip>
            }
            placement="top"
          >
            <FontAwesomeIcon className="ms-3" icon={faQuestionCircle} />
          </OverlayTrigger>
        </span>
      }
      name="hide_internally"
      value={checked}
      onChange={e => onChange(e.target.checked)}
    />
  );
}

HideInternallyCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
